var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWithdraw = function SvgWithdraw(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 20,
    fill: "none",
    viewBox: "0 0 67 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6BCFF",
    d: "M15.417 2.872H4.583C2.053 2.875.003 4.925 0 7.456v.833c0 .23.187.417.417.417h19.166c.23 0 .417-.187.417-.417v-.833c-.003-2.53-2.053-4.58-4.583-4.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9ADFF",
    d: "M17.04 5.602l-1.765-3.528C14.555.634 12.803.049 11.362.77l-.078.04-8.565 4.612c-.202.109-.278.362-.169.564.073.135.214.219.367.219h13.75c.23 0 .416-.187.416-.417 0-.065-.015-.129-.044-.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9684FF",
    d: "M2.917 5.372h14.166C18.694 5.372 20 6.678 20 8.29v8.333c0 1.611-1.306 2.917-2.917 2.917H2.917C1.306 19.539 0 18.233 0 16.622V8.29c0-1.61 1.306-2.917 2.917-2.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9ADFF",
    d: "M19.583 9.539H16.25c-1.61 0-2.916 1.307-2.915 2.918 0 1.61 1.305 2.914 2.915 2.915h3.333c.23 0 .417-.186.417-.416v-5c0-.23-.187-.417-.417-.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9684FF",
    d: "M16.25 13.706c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9684FF",
    d: "M64.163 7.915v4.495L67 11.332 63.07 1.46 47 7.915"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAE7FF",
    d: "M64.98 12.1V7.096H49.036l-1.218.49v.328h16.346v4.495l.818-.31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9684FF",
    d: "M47 7.915h17.163V18.54H47V7.915z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9ADFF",
    d: "M48.635 11.474c.924-.277 1.648-1 1.924-1.925h10.045c.277.925 1 1.649 1.925 1.925v3.506c-.925.277-1.648 1-1.925 1.925H50.56c-.277-.925-1-1.648-1.924-1.925v-3.506z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9684FF",
    d: "M55.582 15.27c1.128 0 2.043-.914 2.043-2.043 0-1.128-.915-2.043-2.043-2.043-1.129 0-2.044.915-2.044 2.043 0 1.129.915 2.043 2.044 2.043z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9ADFF",
    d: "M63.88 7.915l-.969-2.493-.044-.11c-.961.085-1.9-.319-2.5-1.075l-.11.044-8.762 3.634H63.88z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAE7FF",
    d: "M53.466 7.097l-1.97.818H63.88l-.317-.818H53.466z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9684FF",
    d: "M51.087 13.636c.225 0 .408-.183.408-.409 0-.226-.183-.409-.408-.409-.226 0-.41.184-.41.41 0 .225.184.408.41.408zM60.077 13.636c.226 0 .409-.183.409-.409 0-.226-.183-.409-.409-.409-.226 0-.409.184-.409.41 0 .225.183.408.409.408zM37.914 9.777l-3-3.333c-.063-.07-.153-.11-.247-.11h-2c-.132 0-.25.077-.305.197-.053.12-.031.261.057.359L35.218 10l-2.8 3.11c-.087.098-.11.239-.056.359s.173.198.305.198h2c.094 0 .184-.041.248-.11l3-3.334c.114-.126.114-.32 0-.446z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9ADFF",
    d: "M33.581 9.777l-3-3.333c-.063-.07-.153-.11-.247-.11h-2c-.132 0-.251.077-.305.197-.053.12-.031.261.057.359L30.885 10l-2.8 3.11c-.087.098-.11.239-.056.359s.173.198.305.198h2c.094 0 .184-.041.248-.11l3-3.334c.113-.126.113-.32 0-.446z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H20V20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWithdraw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/withdraw.ce2e9d77.svg";
export { ForwardRef as ReactComponent };